<div class="caption">{{camera.district}}, {{camera.trainingCenterName}}</div>
<div class="caption">{{camera.scheme}} - {{camera.companyShortName}}</div>
